import { render, staticRenderFns } from "./editor-controls.vue?vue&type=template&id=f9a787e4&scoped=true&"
import script from "./editor-controls.vue?vue&type=script&lang=ts&"
export * from "./editor-controls.vue?vue&type=script&lang=ts&"
import style0 from "./editor-controls.vue?vue&type=style&index=0&id=f9a787e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9a787e4",
  null
  
)

export default component.exports